/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.nlp.crm.search.rpc.propertysearch.NlpPropertySearchService
 */

/**
 *  Fields must be in VaasPayloadPropertyV2IF first and backfilled into the vector db.
 *  Fields must be Optional.
 */

export let ComHubspotPropertiesData;
(function (_ComHubspotPropertiesData) {})(ComHubspotPropertiesData || (ComHubspotPropertiesData = {}));
export let ComHubspotPropertiesDataPropertiesProtos;
(function (_ComHubspotPropertiesDataPropertiesProtos) {})(ComHubspotPropertiesDataPropertiesProtos || (ComHubspotPropertiesDataPropertiesProtos = {}));
export const searchPropertiesRpc = {
  serviceName: 'com.hubspot.nlp.crm.search.rpc.propertysearch.NlpPropertySearchService',
  rpcName: 'searchProperties',
  auth: 'app',
  fingerprint: 'N9LT1UJyBdFKPwQmh2lUQMUUrF_uj9vp',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const searchPropertiesWithPagingRpc = {
  serviceName: 'com.hubspot.nlp.crm.search.rpc.propertysearch.NlpPropertySearchService',
  rpcName: 'searchPropertiesWithPaging',
  auth: 'app',
  fingerprint: '2d3PFcCwU5uofxb3AMXSEMUUrF_uj9vp',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const searchPropertiesWithRankingDataRpc = {
  serviceName: 'com.hubspot.nlp.crm.search.rpc.propertysearch.NlpPropertySearchService',
  rpcName: 'searchPropertiesWithRankingData',
  auth: 'app',
  fingerprint: 'a6aqQah4_-phVkW874y-XsUUrF_uj9vp',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const searchPropertiesRerankedRpc = {
  serviceName: 'com.hubspot.nlp.crm.search.rpc.propertysearch.NlpPropertySearchService',
  rpcName: 'searchPropertiesReranked',
  auth: 'app',
  fingerprint: 'gXqqcZonfl1hk-sLWJT_EsUUrF_uj9vp',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const searchPropertyRpc = {
  serviceName: 'com.hubspot.nlp.crm.search.rpc.propertysearch.NlpPropertySearchService',
  rpcName: 'searchProperty',
  auth: 'app',
  fingerprint: 'R1qyZ8ub9_im7kfRMqLFK8UUrF_uj9vp',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const searchPropertyWithValuesRpc = {
  serviceName: 'com.hubspot.nlp.crm.search.rpc.propertysearch.NlpPropertySearchService',
  rpcName: 'searchPropertyWithValues',
  auth: 'app',
  fingerprint: 'dw0XIpwGPjCerw3VfyurmsUUrF_uj9vp',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const searchPropertyAndResolveValuesRpc = {
  serviceName: 'com.hubspot.nlp.crm.search.rpc.propertysearch.NlpPropertySearchService',
  rpcName: 'searchPropertyAndResolveValues',
  auth: 'app',
  fingerprint: 'tFdBPm4tS4BDRGhkZesbecUUrF_uj9vp',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const recordPropertyClickedEventRpc = {
  serviceName: 'com.hubspot.nlp.crm.search.rpc.propertysearch.NlpPropertySearchService',
  rpcName: 'recordPropertyClickedEvent',
  auth: 'app',
  fingerprint: 'YrbbJl4_vO9jrY6IsYH1T8UUrF_uj9vp',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};